import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseStepFormComponent } from 'src/app/system-common/base-step-form/base-step-form.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { Location } from '@angular/common';
import { StepItem } from 'src/app/models/common/step-item';
import { PageHeader } from 'src/app/models/common/page-header';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { FieldItem } from 'src/app/models/common/field-item';
import { TabItem } from 'src/app/models/common/tab-items';
import { __await } from 'tslib';
import { hide } from '@popperjs/core';
import { ResponseIO } from 'src/app/models/responseIO';
declare const showSpinner: any;
declare const hideLoader: any;
declare const hideSpinner: any;

@Component({
  selector: '',
  template: '',
})
export class AgentReviewStepFormHandlerComponent extends BaseStepFormComponent<AgentService> implements OnInit {
  applicationStatusCode: string;
  isStatusCode: boolean;
  agentName;
  loggedInCheckerName: string;
  isAcquired: boolean;
  acquiredAlready: boolean;
  checkAquiredName: string;
  appStatusCode;
  public arrvalidationerrors = [];
  public sessionUser;
  completedFlag: boolean = false;
  constructor(
    service: AgentService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
    // this.isStatusCode = false;
    this.isAcquired = false;
    this.acquiredAlready = false;
    this.service.isAuditButtonClicked = false;
    this.arrvalidationerrors = [];
    this.sessionUser = settingService.getSessionStorageValue('USER');
  }

  ngOnInit(): void {
    this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    super.ngOnInit();
    this.loggedInCheckerName = this.settingService.getSessionStorageValue('USER');
    this.loggedInCheckerName = this.loggedInCheckerName.replace(/"/g, '');
    this.loggedInCheckerName = this.loggedInCheckerName.toLocaleLowerCase();
    this.arrvalidationerrors = [];
    this.checkAcquiredAgent();
  }

  protected postLoad(nextStepObj?: StepItem): void {
    this.showErrorMessage();
    this.checkAcquiredAgent();
  }

  public showErrorMessage() {
    this.arrvalidationerrors = [];
    if (
      this.service != undefined &&
      this.service.responseIO != undefined &&
      this.service.responseIO.validationerrors != undefined
    ) {
      Object.keys(this.service.responseIO.validationerrors).forEach((element1) => {
        Object.keys(this.service.responseIO.validationerrors[element1]).forEach((element2) => {
          Object.keys(this.service.responseIO.validationerrors[element1][element2]).forEach((element) => {
            let str = this.service.responseIO.validationerrors[element1][element2][element];
            let strlen = (str.match(/;/g) || []).length;
            if (strlen > 0) {
              for (let i = 0; i < strlen; i++) {
                let validationerror = str.split(';')[i];
                this.arrvalidationerrors.push(validationerror);
              }
            } else {
              this.arrvalidationerrors.push(this.service.responseIO.validationerrors[element1][element2][element]);
            }
          });
        });
      });
    }
  }

  protected getStepList(): StepItem[] {
    let stepList = [
      new StepItem(
        0,
        'step_reviewApp',
        [
          {
            id: 'tab_reviewApp',
            modelList: [
              'Entity',
              'AgentParty',
              'AgentDetail',
              'RelativesList',
              'NomineeList',
              'LicenseList',
              'PaymentList',
              'EducationList',
              'TrainingList',
              'ExamList',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'NotesMode',
              'ServiceSignatureList',
              'QuestionList',
              'ReferenceList',
              'FamilyList',
            ],
          },
        ],
        this.service != undefined &&
        this.service.responseIO != undefined &&
        this.service.responseIO.data != undefined &&
        this.service.responseIO.data.Entity != undefined &&
        this.service.responseIO.validationerrors == undefined &&
        (this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' ||
          this.service.responseIO.data.Entity.applicationStatusCd == 'REQUIREMENT' ||
          this.service.responseIO.data.Entity.applicationStatusCd == 'REJECTED') &&
        sessionStorage.getItem('USER') != 'MAKER'
          ? undefined
          : this.isAcquired
          ? ['btn_Cancel', 'but_Submit']
          : ['Acquire']
      ),
    ];
    return stepList;
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.refNumber = this.service.responseIO.data.Entity.applicationNum;
    header.title = this.settingService.getLabelValue('agent');
    header.moreOptionList = this.getMoreOptionList();
    return header;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'home',
        link: '/home',
      },
      {
        id: 'search',
        link: '/checker-search',
      },
      {
        id: 'Review',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Audit',
        link: '/audit-search/:id',
      },
      {
        id: 'Notes',
      },
    ];
  }

  clickedAuditEvent(data) {
    this.service.isAuditButtonClicked = data;
  }

  public Audit_click(clickedButton: { id: string; link: string }) {
    setTimeout(() => {
      this.openModal('agentAuditPopUp');
      this.service.isAuditButtonClicked = true;
    }, 10);
  }

  closeAgentAuditPopUp() {
    this.closeModal('agentAuditPopUp');
    // this.service.isAuditButtonClicked = false;
  }

  public Notes_click(clickedButton: { id: string; link: string }) {
    $('#addNote').show();
  }

  checkAcquiredAgent() {
    hideLoader();
    if (this.service.responseIO != undefined) {
      this.appStatusCode = this.service.responseIO.data.Entity.applicationStatusCd;
    }
    if (
      this.service.responseIO != undefined &&
      this.service.responseIO.data != undefined &&
      this.service.responseIO.data.AgentDetail != undefined &&
      this.service.responseIO.data.AgentDetail.agentDetailDOField8 != null
    ) {
      this.checkAquiredName = this.service.responseIO.data.AgentDetail.agentDetailDOField8;
      if (this.checkAquiredName.toLocaleLowerCase() != this.loggedInCheckerName) {
        this.acquiredAlready = true;
        this.agentName = this.service.responseIO.data.Entity.applicationNum;
        setTimeout(() => {
          this.openModal('alreadyTaken');
        }, 20);
        // this.stepList[0]['buttonList'] = [];
      } else {
        this.isAcquired = true;
        this.stepList[0]['buttonList'] = ['but_Cancel', 'but_Submit'];
      }
    } else {
      this.stepList[0]['buttonList'] = ['Acquire'];
    }

    if (
      this.service.responseIO != undefined &&
      (this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' ||
        this.service.responseIO.data.Entity.applicationStatusCd == 'REQUIREMENT' ||
        this.service.responseIO.data.Entity.applicationStatusCd == 'REJECTED')
    ) {
      // this.stepList[0]['buttonList'] = [];
      this.isAcquired = false;
    }
  }

  closeAlreadyTakenModal() {
    this.closeModal('alreadyTaken');
    // this.stepList[0]['buttonList'] = [];
    // this.router.navigate(['checker-search']);
  }

  onInputChanged(item: FieldItem) {
    if (this.appStatusCode === 'COMPLETED') {
      this.isAcquired = true;
    }

    if (
      item.model.applicationStatusCd === 'REQUIREMENT' ||
      item.model.applicationStatusCd === 'ONHOLD' ||
      item.model.applicationStatusCd === 'REJECTED'
    ) {
      $('#addNote').show();
    }
  }

  protected async onSaveUpdatedModels(
    body: any,
    currentStepObj: StepItem,
    nextStepObj?: StepItem,
    nextTabObj?: TabItem,
    buttonId?: string
  ) {
    this.service.responseIO.data.Entity.step = 6;
    super.onSaveUpdatedModels(body, currentStepObj, nextStepObj, nextTabObj, buttonId);
    if (this.selectedStep.id == 'step_reviewApp' && buttonId == 'but_Submit') {
      this.service.responseIO.data.Entity.stepActionTabs = undefined;
      // showSpinner();

      this.service.responseIO.data.Entity.step = 6;
      if (this.service.responseIO.data.Entity.applicationStatusCd != 'COMPLETED' && this.completedFlag == false) {
        await this.service.submitAgent().subscribe(
          (successResponse) => {
            if (successResponse['success'] == true) {
              let list = JSON.parse(JSON.stringify(successResponse));
              this.service.responseIO = new ResponseIO();
              this.service.responseIO = list;
              // hideSpinner();
              // setTimeout(() => {
              if (buttonId == 'but_Submit') {
                if (
                  this.service.responseIO.validationerrors == undefined &&
                  (this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' ||
                    this.service.responseIO.data.Entity.applicationStatusCd != 'COMPLETED')
                ) {
                  this.openModal(`submitAgentModal`);
                } else if (this.service.responseIO.validationerrors != undefined) {
                  this.onViewErrorClick();
                }
              }
              // this.openModal(`submitAgentModal`);
              // }, 2000);
            }
          },
          (error) => {
            console.log('Agent submit failed.');
            console.log('Error:', error);
          }
        );
      }
    }
  }

  protected saveUpdatedModels(
    currentStepObj: StepItem,
    nextStepObj?: StepItem,
    nextTabObj?: TabItem,
    buttonId?: string
  ) {
    //super.saveUpdatedModels(currentStepObj, nextStepObj, nextTabObj, buttonId);

    let service = this.altService != undefined ? this.altService : this.service;
    let modelNameList;
    if (nextTabObj != undefined && nextTabObj != null) {
      modelNameList = nextTabObj.modelList;
    } else {
      modelNameList =
        currentStepObj.selectedTab == undefined
          ? currentStepObj.tabList[0].modelList
          : currentStepObj.selectedTab.modelList;
    }

    let modelNameBodyList = this.getModelNameBodyList(modelNameList);
    service.responseIO.data.Entity.step = 6;
    this.setVisitedTabs();
    //set the action as continue with the current step tab list
    if (
      nextStepObj != null &&
      (nextStepObj.index != currentStepObj.index || nextStepObj.index == this.stepList.length - 1)
    ) {
      this.setStepActionTab(currentStepObj);
    }
    //responseUpdated
    this.responseUpdated = false;
    this.isDataSaved = false;

    if (nextTabObj != null) service.currentActiveTab = nextTabObj.id;
    else if (currentStepObj != null && currentStepObj.selectedTab != null)
      service.currentActiveTab = currentStepObj.selectedTab.id;
    // else if(nextStepObj!=null)
    //     service.currentActiveTab = nextStepObj.tabList[0].id;
    //set currentActiveField as undefined..no need of that currentActiveField on save...because of this dual case issue occurs.
    service.currentActiveField = undefined;
    service.process(service.id, modelNameBodyList).subscribe(
      async (body) => {
        this.isDataSaved = true;
        await this.onSaveUpdatedModels(body, currentStepObj, nextStepObj, nextTabObj, buttonId);
        if (buttonId == 'Acquire') this.openAcquireModal();
        else if (buttonId == 'but_Submit') {
          if (this.service.responseIO.data.Entity.applicationStatusCd === 'COMPLETED') {
            if (this.service.responseIO.validationerrors != undefined) {
              this.onViewErrorClick();
            } else {
              this.openModal('submitAgentModal');
              this.service.responseIO.data.AgentDetail.agentDetailDOField8 = null;
            }
          } else if (this.service.responseIO.data.Entity.applicationStatusCd != 'COMPLETED') {
            if (this.service.responseIO.validationerrors != undefined) {
              this.onViewErrorClick();
            }
          }
        } else if (buttonId == 'btn_Cancel') this.openModal('acquireModal');
      },
      (error) => {
        console.log('Data updated failed.');
        console.log('Error:', error);
      }
    );
  }
  protected but_Submit_click() {
    console.log(' but_Submit_click --' + this.service.responseIO.data.Entity.applicationStatusCd);
    if (
      this.service.responseIO.data.Entity.applicationStatusCd != null &&
      this.service.responseIO.data.Entity.applicationStatusCd != undefined &&
      this.service.responseIO.data.Entity.applicationStatusCd != ''
    ) {
      this.applicationStatusCode = this.service.responseIO.data.Entity.applicationStatusCd;
      this.isStatusCode = true;
      this.agentName = this.service.responseIO.data.Entity.applicationNum;
      this.service.responseIO.data.AgentDetail.agentDetailDOField8 = null;
      // this.service.responseIO.data.Entity.buttonClicked='Submit';
      if (
        this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' &&
        (this.service.responseIO.data.Entity.intfStatusCd == null ||
          this.service.responseIO.data.Entity.intfStatusCd != 'SUCCESS')
      ) {
        this.completedFlag = true;
      }

      this.saveUpdatedModels(this.selectedStep, undefined, undefined, 'but_Submit');
      // setTimeout(() => {
      //this.openModal(`submitAgentModal`);
      // }, 2000);
    } else {
      this.isStatusCode = false;
      if (this.service.responseIO.data.Entity.applicationStatusCd == null) {
        if (this.service.responseIO.validationerrors == null) {
          this.arrvalidationerrors = [];
          this.arrvalidationerrors.push('Please choose one decision');
          this.openModal('errorModal');
        }
      }
    }
  }

  closeCheckerModal() {
    this.closeModal(`submitAgentModal`);
  }

  closeAcquireModal() {
    this.closeModal(`acquireModal`);
    if (this.service.responseIO.data.AgentDetail.agentDetailDOField8 != null) {
      // this.isAcquired = true;
      this.stepList[0]['buttonList'] = ['btn_Cancel', 'but_Submit'];

      // setTimeout(() => {
      //   var element = <HTMLInputElement>document.getElementById('but_Submit');
      //   element.disabled = true;
      // }, 2000);
    } else {
      // this.isAcquired = false;
      this.stepList[0]['buttonList'] = ['Acquire'];
    }
    this.settingService.reloadCurrentRoute();
  }

  redirectToHome() {
    this.service.hideLoader(true);
    this.closeModal(`submitAgentModal`);
    this.settingService.reloadCurrentRoute();
    // window.location.reload();
    // if (this.isStatusCode) {
    //   setTimeout(() => {
    //     this.router.navigate(['home']);
    //   }, 1000);
    // }
  }

  Acquire_click() {
    console.log(' Acquire_click --' + this.service.responseIO.data.Entity.applicationStatusCd);
    let dateTime = new Date();
    let agentStatusDt = dateTime.toISOString();

    if (this.service.responseIO.data.AgentDetail.agentDetailDOField8 != null) {
      if (this.service.responseIO.data.AgentDetail.agentDetailDOField8 === this.loggedInCheckerName) {
        this.acquiredAlready = true;
        // this.stepList[0]['buttonList'] = [];
        this.router.navigate(['checker-search']);
      }
    } else {
      this.isAcquired = true;
      this.service.responseIO.data.AgentDetail.agentDetailDOField8 = this.loggedInCheckerName;
      this.agentName = this.service.responseIO.data.Entity.applicationNum;
      this.service.responseIO.data.AgentDetail.agentStatusDt = agentStatusDt;
      //super.but_DraftSave_click();
      this.saveUpdatedModels(this.selectedStep, null, null, 'Acquire');
    }
  }

  openAcquireModal() {
    setTimeout(() => {
      this.openModal('acquireModal');
    }, 20);
  }

  btn_Cancel_click() {
    this.service.responseIO.data.Entity.applicationStatusCd = this.appStatusCode;
    this.service.responseIO.data.AgentDetail.agentDetailDOField8 = null;
    this.agentName = this.service.responseIO.data.Entity.applicationNum;
    // super.but_DraftSave_click();
    this.isAcquired = false;
    this.saveUpdatedModels(this.selectedStep, null, null, 'btn_Cancel');
    // setTimeout(() => {
    // this.openModal('acquireModal');
    // }, 2000);
  }

  public onInputFocused(item: FieldItem) {
    let functionName;
    // if(item.index != undefined && item.index != null){
    // functionName = item.fieldID.replace('_'+ item.index, '') +'_change'
    // }else{
    functionName = item.fieldCd + '_focus';
    // }
    //   console.log(functionName)
    if (typeof this[functionName] === 'function') {
      eval('this.' + functionName + '(item)');
    }
  }

  onApplicationStatusFieldCreated(fieldItemArray: FieldItem) {
    this.setApplicationStatusCdValues(fieldItemArray[0]);
  }

  setApplicationStatusCdValues(item: FieldItem) {
    if (this.appStatusCode === 'SUBMITTED' || this.appStatusCode === 'RESUBMITTED') {
      item['options'] = [
        { cd: 'APPROVED', desc: 'Approved' },
        { cd: 'ONHOLD', desc: 'On-Hold' },
        { cd: 'REJECTED', desc: 'Rejected' },
        { cd: 'REQUIREMENT', desc: 'Requirement' },
      ];
    } else if (this.appStatusCode === 'APPROVED') {
      item['options'] = [
        { cd: 'ONHOLD', desc: 'On-Hold' },
        { cd: 'REJECTED', desc: 'Rejected' },
        { cd: 'REQUIREMENT', desc: 'Requirement' },
        { cd: 'COMPLETED', desc: 'Completed' },
      ];
    } else if (this.appStatusCode === 'REQUIREMENT') {
      item['options'] = [
        { cd: 'APPROVED', desc: 'Approved' },
        { cd: 'ONHOLD', desc: 'On-Hold' },
        { cd: 'REJECTED', desc: 'Rejected' },
      ];
    } else if (this.appStatusCode === 'ONHOLD') {
      item['options'] = [
        { cd: 'APPROVED', desc: 'Approved' },
        // { cd: 'ONHOLD', desc: 'On-Hold' },
        { cd: 'REJECTED', desc: 'Rejected' },
        { cd: 'REQUIREMENT', desc: 'Requirement' },
      ];
    } else if (this.appStatusCode === 'REJECTED' || this.appStatusCode === 'COMPLETED') {
      item['options'] = [];
    } else {
      item['options'] = [
        { cd: 'APPROVED', desc: 'Approved' },
        { cd: 'COMPLETED', desc: 'Completed' },
        { cd: 'ONHOLD', desc: 'On-Hold' },
        { cd: 'REJECTED', desc: 'Rejected' },
        { cd: 'REQUIREMENT', desc: 'Requirement' },
        { cd: 'SUBMITTED', desc: 'Submitted' },
      ];
    }
  }
  /**
   * This open the Error modal
   */
  onViewErrorClick() {
    this.showErrorMessage();
    this.openModal('errorModal');
  }
  /**
   * This close the Error modal
   */
  closeErrorModal() {
    this.closeModal('errorModal');
    this.service.reloadCurrentRoute();
  }
}
